import config from '../../constants/global'
import { Link } from 'react-router-dom'
import USER_TYPE from '../../constants/userType'
import DisplayForUserType from '../auth/DisplayForUserType'
import { useAuth } from '../../contexts/AuthContext'

export const Footer = () => {
  const { userType } = useAuth()

  const getFooterMessage = () => {
    switch (userType) {
      case USER_TYPE.guest:
      case USER_TYPE.customer:
        return 'Find it. Bargain it. Get it — all on Sokooni.'
      case USER_TYPE.retailer:
        return 'Grow your sales on Sokooni — showcase your products, connect with ready buyers, and close deals faster with direct chats and smart offers.'
      case USER_TYPE.wholeseller:
        return 'Reach more retailers, move products faster — list your wholesale deals on Sokooni and connect directly with bulk buyers.'
      default:
        return 'Discover more on Sokooni — find great deals, connect with sellers and buyers, and bargain your way to the perfect price.'
    }
  }

  return (
    <footer className="w-full bg-background border-t border-gray-200">
      <div className="main-container mx-auto py-4">
        <div className="flex flex-col items-center space-y-6">
          <div className="flex flex-col items-center">
            <img
              src={'/eastsoko-logo.png'}
              alt="Sokooni"
              className="h-10 w-auto object-contain mb-3"
            />
            <p className="font-inter text-sm text-gray-600 text-center lg:text-left leading-relaxed">
              {getFooterMessage()}
            </p>
          </div>

          <DisplayForUserType userTypes={[USER_TYPE.guest]}>
            <div className="flex flex-col sm:flex-row items-center gap-4">
              <Link
                to="/signup/retailer"
                className="font-inter font-medium text-sm text-secondary-600 underline transition-colors duration-200"
              >
                Become A Retailer
              </Link>
              <Link
                to="/signup/wholesaler"
                className="font-inter font-medium text-sm text-secondary-600 underline transition-colors duration-200"
              >
                Become A Wholesaler
              </Link>
            </div>
          </DisplayForUserType>

          <div className="flex flex-wrap justify-center  gap-x-6 gap-y-2">
            <Link
              to="/pricing"
              className="font-inter text-sm text-gray-600 hover:text-gray-900 transition-colors duration-200"
            >
              Pricing
            </Link>
            <Link
              to="/privacy-policy"
              className="font-inter text-sm text-gray-600 hover:text-gray-900 transition-colors duration-200"
            >
              Privacy
            </Link>
            <Link
              to="/terms"
              className="font-inter text-sm text-gray-600 hover:text-gray-900 transition-colors duration-200"
            >
              Terms
            </Link>
            <Link
              to="/return-policy"
              className="font-inter text-sm text-gray-600 hover:text-gray-900 transition-colors duration-200"
            >
              Returns
            </Link>
          </div>
        </div>

        <div className="mt-6 pt-4 border-t border-gray-200 text-center ">
          <p className="font-inter text-xs text-gray-500">
            © {new Date().getFullYear()} Sokooni. All rights reserved.
            {!config.inProduction && <span className="text-gray-400 ml-2">{config.version}</span>}
          </p>
        </div>
      </div>
    </footer>
  )
}
